import React from 'react';
import SelectDropdown from "../../input/SelectDropdown";
import { Relationship } from "../../enums/Relationship";
import { useAuth } from "oidc-react";
import { useFormikContext } from "formik";
import { Party } from "../../enums/Party";
import { FormValues } from "../../common/FormValues";
import { Dependent } from "../../../generated/graphql";
import { useOwnMember } from "../../../hooks/useOwnMember";

const DependentChoice = () => {
    const { values, setFieldValue } = useFormikContext<FormValues>();
    const relationship = values.relationship;
    const party = values.party;
    const auth = useAuth();

    const { data: memberData } = useOwnMember(auth);

    const employeeFiling = Party.EMPLOYEE === party
    const dependentRelationship = Relationship.COVERED_DEPENDENT === relationship;
    const member = memberData?.findOwnMember
    if(!employeeFiling || !dependentRelationship) {
        return null;
    } else if(!member?.dependents?.length) {
        return null;
    }
    return <SelectDropdown id="dependents" label="Dependents" required={false}
                           options={member?.dependents?.map((d: Dependent, index: number) => {
                               return ({
                                   id: "" + index,
                                   text: `${(buildFullNameFor(d))} (Date of birth: ${d.dateOfBirth})`,
                                   value: d.id
                               });
                           })}
                           changeCallback={(target: HTMLInputElement) => {
                               const dependent = member.dependents.find(d => d.id === target.value);
                               setFieldValue("patientFirstName", dependent?.firstName ?? "");
                               setFieldValue("patientLastName", dependent?.lastName ?? "")
                               setFieldValue("patientDateOfBirth", dependent?.dateOfBirth ?? "");
                           }}/>
};

function buildFullNameFor(d?: Dependent) {
    if(!d) {
        return ''
    }
    return `${d.firstName} ${d.middleName ? `${d.middleName} ` : ''}${d.lastName}`;
}

export default DependentChoice;